// FeaturedProducts.js
import React, { useRef } from 'react';
import Slider from 'react-slick';
import FeaturedProductCard from '../FeaturedProductCard/FeaturedProductCard';
import './FeaturedProducts.css';
// import rightChevron from '../../../assets/logos_icons/chevron_right.png';
// import leftChevron from '../../../assets/logos_icons/chevron_left.png';

const products = [
  {
    name: 'Pelapower',
    image: 'https://mcusercontent.com/b3b72a7d8d7f00a383a083fd9/images/bfb98ae3-04e0-b5d5-a8ba-35f7e0c10ff2.png',
    url: 'https://www.pharm-rx.store/products/pharm-rx-chemical-corp',
  },
  {
    name: 'Kannaease',
    image: 'https://mcusercontent.com/b3b72a7d8d7f00a383a083fd9/images/8c91051e-a612-320b-e181-d1d8fe9fb25c.png',
    url: 'https://www.pharm-rx.store/products/pharm-rx-chemical-corp-c53cf7fc-68a9-46c0-bc12-0a1e5219de6e',
  },
  {
    name: 'Pelapower',
    image: 'https://mcusercontent.com/b3b72a7d8d7f00a383a083fd9/images/bfb98ae3-04e0-b5d5-a8ba-35f7e0c10ff2.png',
    url: 'https://www.pharm-rx.store/products/pharm-rx-chemical-corp',
  },
];

const FeaturedProducts = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // const goToNext = () => {
  //   if (sliderRef.current) {
  //     sliderRef.current.slickNext();
  //   }
  // };

  // const goToPrev = () => {
  //   if (sliderRef.current) {
  //     sliderRef.current.slickPrev();
  //   }
  // };

  return (
    <div className="featured-products container">
      <div className="featured-products-header">
        <h2>Pharm-Rx Exclusive Products</h2>
      </div>
      {/* <div className="carousel-navigation">
        <button onClick={goToPrev} className="carousel-nav-button">
          <img src={leftChevron} alt="Previous" />
        </button>
        <button onClick={goToNext} className="carousel-nav-button">
          <img src={rightChevron} alt="Next" />
        </button>
      </div> */}
      <Slider ref={sliderRef} {...settings} className="featured-products-slider">
        {products.map((product) => (
          <div key={product.name} className="featured-product-slide">
            <FeaturedProductCard {...product} />
          </div>
        ))}
      </Slider>
      {/* <div className="view-all-button-container">
        <a
          className="view-all-button"
          href="https://www.pharm-rx.store/products"
          target="_blank"
          rel="noopener noreferrer"
        >
          Shop All Products
        </a>
      </div> */}
    </div>
  );
};

export default FeaturedProducts;
